import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { KeyboardDateTimePicker } from "mui-rff";

import { styles } from "./DateTimePicker.styles";

function DateTimePicker({ classes, id, label, required, placeholder }) {
  return (
    <div className={classes.root}>
      <KeyboardDateTimePicker
        label={label}
        name={id}
        required={required}
        autoOk
        disableToolbar
        ampm={false}
        variant="inline"
        format="DD-MM-yyyy HH:mm"
      />
    </div>
  );
}

export default withStyles(styles)(DateTimePicker);
